module.exports = __webpack_public_path__ + "static/tatianawork3-43958e672062641d5d585615368748a9.jpeg";